/* possoftware/actions */
import { action } from "typesafe-actions";
import { PosSoftware, PosSoftwareActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(PosSoftwareActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: PosSoftware) =>
  action(PosSoftwareActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(PosSoftwareActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: PosSoftware | null) => unknown
) => action(PosSoftwareActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: PosSoftware) =>
  action(PosSoftwareActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(PosSoftwareActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(PosSoftwareActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () =>
  action(PosSoftwareActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(PosSoftwareActionTypes.DELETE_ERROR, error);
